import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

export const Contact = () => {
  const form = useRef();

  const handleSubmit =  (e) => {
    e.preventDefault();

    emailjs.sendForm('service_elau01q', 'template_25bu9db', form.current, 'A2g4VGaU3mjQcIXZ2')
      .then((result) => {
          console.log(result.text);
          alert("Message sent succesfully")
          e.target.reset();
      }, (error) => {
          console.log(error.text);
      });
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>
              }
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h2>Get In Touch</h2>
                <form ref={form} onSubmit={handleSubmit}>
                  <Row>
                    <Col size={12} sm={6} className="px-1">
                    <input type="text" name="user_name" placeholder="name"/>
                    </Col>
                    
                    <Col size={12} sm={6} className="px-1">
                    <input type="email" name="user_email" placeholder="email"/>
                    </Col>
                    
                    <Col size={12} className="px-1">
                    <textarea name="message" placeholder="message"/>
                      <button type="submit"><span>Send</span></button>
                    </Col>
                    
                  </Row>
                </form>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
